import { render, staticRenderFns } from "./center_detail.vue?vue&type=template&id=315a842c"
import script from "./center_detail.vue?vue&type=script&lang=js"
export * from "./center_detail.vue?vue&type=script&lang=js"
import style0 from "./center_detail.vue?vue&type=style&index=0&id=315a842c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports